const esc = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const parseMoney = (value) => Number(String(value || "").replace(/\D/g, "")) || 0;
const fmt = (value) => new Intl.NumberFormat("vi-VN").format(parseMoney(value));

const splitDate = (text = "") => {
  const [day = "...", month = "...", year = "...."] = String(text).split("/");
  return { day, month, year };
};

export const getPrintTemplate = ({ data }) => {
  const { day, month, year } = splitDate(data.documentDate);

  const assetRows = (data.assets || [])
    .map(
      (item, index) => `
      <tr>
        <td class="c">${index + 1}</td>
        <td>${esc(item.nameSpecification)}</td>
        <td class="c">${esc(item.assetCode)}</td>
        <td class="c">${esc(item.countryOfOrigin)}</td>
        <td class="c">${esc(item.productionYear)}</td>
        <td class="c">${esc(item.startUseYear)}</td>
        <td class="c">${esc(item.capacity)}</td>
        <td class="r">${fmt(item.purchasePrice)}</td>
        <td class="r">${fmt(item.transferCost)}</td>
        <td class="r">${fmt(item.trialCost)}</td>
        <td class="r">${fmt(item.otherCost)}</td>
        <td class="r">${fmt(item.originalCost)}</td>
        <td class="c">${esc(item.technicalDocument)}</td>
      </tr>
    `
    )
    .join("");

  const accessoryRows = (data.accessories || [])
    .map(
      (item, index) => `
      <tr>
        <td class="c">${index + 1}</td>
        <td>${esc(item.nameSpecification)}</td>
        <td class="c">${esc(item.unit)}</td>
        <td class="r">${fmt(item.quantity)}</td>
        <td class="r">${fmt(item.value)}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <title>Biên Bản Giao Nhận TSCĐ</title>
      <style>
        @media print { @page { margin: 10mm 8mm 14mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 13px; color: #000; padding: 10px; }
        .header { display:flex; justify-content:space-between; }
        .center { text-align:center; }
        table { border-collapse: collapse; width: 100%; margin-top: 8px; }
        th, td { border: 1px solid #000; padding: 3px 4px; vertical-align: middle; }
        th { font-weight: 700; text-align: center; }
        .c { text-align: center; }
        .r { text-align: right; }
        .line { margin-top: 6px; }
        .sign { display:flex; justify-content:space-between; text-align:center; margin-top: 18px; }
        .sign-box { width: 24%; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div>
          <div><b>Đơn vị:</b> ${esc(data.unit)}</div>
          <div><b>Bộ phận:</b> ${esc(data.department)}</div>
        </div>
        <div class="center">
          <div><b>Mẫu số 01 - TSCĐ</b></div>
          <div><i>(Ban hành theo Thông tư số 200/2014/TT-BTC</i></div>
          <div><i>Ngày 22/12/2014 của Bộ Tài chính)</i></div>
        </div>
      </div>

      <h2 class="center" style="margin:10px 0 4px;">BIÊN BẢN GIAO NHẬN TSCĐ</h2>
      <div class="center">Ngày ${esc(day)} tháng ${esc(month)} năm ${esc(year)}</div>
      <div style="display:flex; justify-content:flex-end; gap:20px; margin-top:6px;">
        <div>Số: ${esc(data.documentNumber)}</div>
        <div>Nợ: ${esc(data.debitAccount)}</div>
        <div>Có: ${esc(data.creditAccount)}</div>
      </div>

      <div class="line">Căn cứ Quyết định số: ${esc(data.decisionNumber)} ngày ${esc(data.decisionDate)} của ${esc(data.decisionBy)}</div>
      <div class="line">Về việc bàn giao TSCĐ: ${esc(data.decisionReason)}</div>
      <div class="line">Ban giao nhận TSCĐ gồm:</div>
      <div class="line">- Ông/Bà ${esc(data.giverName)} chức vụ ${esc(data.giverTitle)} Đại diện bên giao</div>
      <div class="line">- Ông/Bà ${esc(data.receiverName)} chức vụ ${esc(data.receiverTitle)} Đại diện bên nhận</div>
      <div class="line">- Ông/Bà ${esc(data.witnessName)} chức vụ ${esc(data.witnessTitle)} Đại diện ${esc(data.witnessDepartment)}</div>
      <div class="line">Địa điểm giao nhận TSCĐ: ${esc(data.handoverLocation)}</div>
      <div class="line">Xác nhận việc giao nhận TSCĐ như sau:</div>

      <table>
        <thead>
          <tr>
            <th>STT</th>
            <th>Tên, ký hiệu quy cách (cấp hạng TSCĐ)</th>
            <th>Số hiệu TSCĐ</th>
            <th>Nước sản xuất</th>
            <th>Năm sản xuất</th>
            <th>Năm đưa vào sử dụng</th>
            <th>Công suất</th>
            <th>Giá mua</th>
            <th>Chi phí vận chuyển</th>
            <th>Chi phí chạy thử</th>
            <th>Chi phí khác</th>
            <th>Nguyên giá TSCĐ</th>
            <th>Tài liệu kỹ thuật kèm theo</th>
          </tr>
        </thead>
        <tbody>
          ${assetRows}
          <tr>
            <td></td>
            <td class="c"><b>Cộng</b></td>
            <td class="c">x</td>
            <td class="c">x</td>
            <td class="c">x</td>
            <td class="c">x</td>
            <td class="c">x</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="r"><b>${fmt(data.totalOriginalCost)}</b></td>
            <td class="c">x</td>
          </tr>
        </tbody>
      </table>

      <div style="margin-top:8px; text-align:center;"><b>DỤNG CỤ, PHỤ TÙNG KÈM THEO</b></div>
      <table>
        <thead>
          <tr>
            <th>Số thứ tự</th>
            <th>Tên, quy cách dụng cụ, phụ tùng</th>
            <th>Đơn vị tính</th>
            <th>Số lượng</th>
            <th>Giá trị</th>
          </tr>
        </thead>
        <tbody>
          ${accessoryRows}
        </tbody>
      </table>

      <div class="sign">
        <div class="sign-box"><b>Giám đốc bên nhận</b><br/><i>(Ký, họ tên, đóng dấu)</i><div style="height:52px;"></div></div>
        <div class="sign-box"><b>Kế toán trưởng bên nhận</b><br/><i>(Ký, họ tên)</i><div style="height:52px;"></div></div>
        <div class="sign-box"><b>Người nhận</b><br/><i>(Ký, họ tên)</i><div style="height:52px;"></div></div>
        <div class="sign-box"><b>Người giao</b><br/><i>(Ký, họ tên)</i><div style="height:52px;"></div></div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>`;
};
